/**
 * Created by chenggong on 2018/3/29.
 */
import Axios from 'axios'
import { Message, Loading } from 'element-ui'

import store from '../store/store'
import router from '../router/index'

// 定义loading变量
let loading
// 使用Element loading-start 方法
function startLoading () {
  loading = Loading.service({
    lock: true,
    text: 'TIRECOOL',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
// 使用Element loading-close 方法
function endLoading () {
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

function showMessage (msg) {
  Message.warning(msg)
}

Axios.interceptors.request.use(
  config => {
    let token = store.state.userInfo.token
    if (token) {
      config.headers.Authorization = `DSS ${token}`
    }
    showFullScreenLoading()
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

Axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    return response
  },
  error => {
    let res = error.response
    tryHideFullScreenLoading()
    switch (res.status) {
      case 400:
        showMessage('400 错误')
        router.push('/login')
        break
      case 401:
        // 返回 401 清楚token信息并跳转到登录页面
        showMessage('401 没有登录')
        router.push('/login')
        break
      case 403:
        showMessage('403 您没有该操作权限')
        break
      case 500:
        showMessage('500 服务器错误')
        break
      case 504:
        showMessage('504 服务超时')
        break
    }
    return Promise.reject(error.response.data)
  }
)



// WEBPACK FOOTER //
// ./src/axios/index.js